<p-toast></p-toast>
<div class="tecGym-component-Loading" *ngIf="loading">
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" fill="#fff" width="30px">
        <path
            d="M304 48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm0 416a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM48 304a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm464-48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM142.9 437A48 48 0 1 0 75 369.1 48 48 0 1 0 142.9 437zm0-294.2A48 48 0 1 0 75 75a48 48 0 1 0 67.9 67.9zM369.1 437A48 48 0 1 0 437 369.1 48 48 0 1 0 369.1 437z" />
    </svg>
</div>
<div class="tecGym-component dashboard">
    <div class="tecGym-component-body">
        <div class="header-main">
            <h1>
                {{setLabel("dashboardLabel")}}
            </h1>
            <div class="dropdown-main">
                <div class="dropdownDiv">
                    <span style="color: #bfbfbf;" class="stat-label">{{setLabel("selectMonthLabel")}}</span>
                    <div style="color: white; border: 1px solid #0e2031; border-radius: 10em; height: 2em;"
                        class="filterFields">
                        <p-dropdown class="p-inputtext" [options]="monthOptions" name="month" required
                            [(ngModel)]="monthValue" (onChange)="onChange()">
                        </p-dropdown>
                    </div>
                </div>
                <div class="dropdownDiv">
                    <span style="color: #bfbfbf;" class="stat-label">{{setLabel("selectYearLabel")}}</span>
                    <div style=" color: white;border: 1px solid #0e2031;border-radius: 10em;height: 2em;"
                        class="filterFields">
                        <p-dropdown class="p-inputtext" [options]="yearOptions" name="year" required
                            (onChange)="onChange()" [(ngModel)]="yearValue">
                        </p-dropdown>
                    </div>
                </div>
            </div>
        </div>
        <div class="container">
            <div class="tecGym-component-stats">
                <div class="stats-item">
                    <span class="stat-label">{{setLabel("totalSalesLabel")}}</span>
                    <span class="stat-value">{{this.data.totalSales | number:'1.0-0'}}</span>
                </div>
                <div class="stats-item">
                    <span class="stat-label">{{setLabel("newMembersRegisteredLabel")}}</span>
                    <span class="stat-value">{{this.data.newMemberRegistered}}</span>
                </div>
                <div class="stats-item">
                    <span class="stat-label">{{setLabel("totalActiveCustomersLabel")}}</span>
                    <span class="stat-value">{{this.data.activeCustomers}}</span>
                </div>
                <div class="stats-item">
                    <span class="stat-label">{{setLabel("defaultersLabel")}}</span>
                    <span class="stat-value">{{this.data.defaulters}}</span>
                </div>
                <div class="stats-item">
                    <span class="stat-label">{{setLabel("activeMembersThisMonthLabel")}}</span>
                    <span class="stat-value">{{this.data.activemembersthismonth}}</span>
                </div>
                <div class="stats-item">
                    <span class="stat-label">{{setLabel("totalVisitorsLabel")}}</span>
                    <span class="stat-value">{{this.data.visitors}}</span>
                </div>
                <div class="stats-item">
                    <span class="stat-label">{{setLabel("totalInquiryLabel")}}</span>
                    <span class="stat-value">{{this.data.enquiries}}</span>
                </div>
            </div>
        </div>
        <div *ngIf="branch._id == '67728682419e66d9220356ec'" class="container">
            <div class="tecGym-kpi" [class]="kpiMainState">
                <div class="tecGym-kpi-item">
                    <h6>Churn Rate</h6>
                    <h1>{{currentChurnRateKPIValue}}</h1>
                    <div class="kpi-comp-main">
                        <div class="kpi-comp-main-change">
                            <label [class]="churnRateStatus">
                                <span class="kpiStateIcon" id="downKpi">
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512" fill="green"><!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.--><path d="M384 352c-17.7 0-32 14.3-32 32s14.3 32 32 32l160 0c17.7 0 32-14.3 32-32l0-160c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 82.7L342.6 137.4c-12.5-12.5-32.8-12.5-45.3 0L192 242.7 54.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0L320 205.3 466.7 352 384 352z"/></svg>
                                </span>
                                <span class="kpiStateIcon" id="upKpi">
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512" fill="red"><!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.--><path d="M384 160c-17.7 0-32-14.3-32-32s14.3-32 32-32l160 0c17.7 0 32 14.3 32 32l0 160c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-82.7L342.6 374.6c-12.5 12.5-32.8 12.5-45.3 0L192 269.3 54.6 406.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l160-160c12.5-12.5 32.8-12.5 45.3 0L320 306.7 466.7 160 384 160z"/></svg>
                                </span>
                                <span class="kpiStateIcon" id="unchangedKpi">
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" fill="orange"><!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.--><path d="M432 256c0 17.7-14.3 32-32 32L48 288c-17.7 0-32-14.3-32-32s14.3-32 32-32l352 0c17.7 0 32 14.3 32 32z"/></svg>
                                </span>
                                {{diffChurnRateKPIValue}}
                            </label>
                            <p>Change</p>
                        </div>
                        <div class="kpi-comp-main-comp">
                            <label>{{lastChurnRateKPIValue}}</label>
                            <p>VS last Month</p>
                        </div>
                    </div>
                </div>
                <div class="tecGym-kpi-item">
                    <h6>Sales</h6>
                    <h1>{{currentSalesRateKPIValue | shortCurrency:'Rs' }}</h1>
                    <div class="kpi-comp-main">
                        <div class="kpi-comp-main-change">
                            <label [class]="salesStatus">
                                <span class="kpiStateIcon" id="downKpi">
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512" fill="red"><!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.--><path d="M384 352c-17.7 0-32 14.3-32 32s14.3 32 32 32l160 0c17.7 0 32-14.3 32-32l0-160c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 82.7L342.6 137.4c-12.5-12.5-32.8-12.5-45.3 0L192 242.7 54.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0L320 205.3 466.7 352 384 352z"/></svg>
                                </span>
                                <span class="kpiStateIcon" id="upKpi">
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512" fill="green"><!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.--><path d="M384 160c-17.7 0-32-14.3-32-32s14.3-32 32-32l160 0c17.7 0 32 14.3 32 32l0 160c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-82.7L342.6 374.6c-12.5 12.5-32.8 12.5-45.3 0L192 269.3 54.6 406.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l160-160c12.5-12.5 32.8-12.5 45.3 0L320 306.7 466.7 160 384 160z"/></svg>
                                </span>
                                <span class="kpiStateIcon" id="unchangedKpi">
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" fill="orange"><!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.--><path d="M432 256c0 17.7-14.3 32-32 32L48 288c-17.7 0-32-14.3-32-32s14.3-32 32-32l352 0c17.7 0 32 14.3 32 32z"/></svg>
                                </span>
                                {{diffSalesKPIValue | shortCurrency:''}}
                            </label>
                            <p>Change</p>
                        </div>
                        <div class="kpi-comp-main-comp">
                            <label>{{lastSalesKPIValue | shortCurrency:''}}</label>
                            <p>VS last Month</p>
                        </div>
                    </div>
                </div>
                <div class="tecGym-kpi-item">
                    <h6>Trainer Sales</h6>
                    <h1>{{currentTrainerSalesKPIValue | shortCurrency:'Rs' }}</h1>
                    <div class="kpi-comp-main">
                        <div class="kpi-comp-main-change">
                            <label [class]="trainerSalesStatus">
                                <span class="kpiStateIcon" id="downKpi">
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512" fill="red"><!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.--><path d="M384 352c-17.7 0-32 14.3-32 32s14.3 32 32 32l160 0c17.7 0 32-14.3 32-32l0-160c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 82.7L342.6 137.4c-12.5-12.5-32.8-12.5-45.3 0L192 242.7 54.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0L320 205.3 466.7 352 384 352z"/></svg>
                                </span>
                                <span class="kpiStateIcon" id="upKpi">
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512" fill="green"><!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.--><path d="M384 160c-17.7 0-32-14.3-32-32s14.3-32 32-32l160 0c17.7 0 32 14.3 32 32l0 160c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-82.7L342.6 374.6c-12.5 12.5-32.8 12.5-45.3 0L192 269.3 54.6 406.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l160-160c12.5-12.5 32.8-12.5 45.3 0L320 306.7 466.7 160 384 160z"/></svg>
                                </span>
                                <span class="kpiStateIcon" id="unchangedKpi">
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" fill="orange"><!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.--><path d="M432 256c0 17.7-14.3 32-32 32L48 288c-17.7 0-32-14.3-32-32s14.3-32 32-32l352 0c17.7 0 32 14.3 32 32z"/></svg>
                                </span>
                                {{diffTrainerSalesKPIValue | shortCurrency:''}}
                            </label>
                            <p>Change</p>
                        </div>
                        <div class="kpi-comp-main-comp">
                            <label>{{lastTrainerSalesKPIValue | shortCurrency:''}}</label>
                            <p>VS last Month</p>
                        </div>
                    </div>
                </div>
                <div class="tecGym-kpi-item">
                    <h6>New Members</h6>
                    <h1>{{currentNewMembersRateKPIValue}}</h1>
                    <div class="kpi-comp-main">
                        <div class="kpi-comp-main-change">
                            <label [class]="newMembersStatus">
                                <span class="kpiStateIcon" id="downKpi">
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512" fill="red"><!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.--><path d="M384 352c-17.7 0-32 14.3-32 32s14.3 32 32 32l160 0c17.7 0 32-14.3 32-32l0-160c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 82.7L342.6 137.4c-12.5-12.5-32.8-12.5-45.3 0L192 242.7 54.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0L320 205.3 466.7 352 384 352z"/></svg>
                                </span>
                                <span class="kpiStateIcon" id="upKpi">
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512" fill="green"><!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.--><path d="M384 160c-17.7 0-32-14.3-32-32s14.3-32 32-32l160 0c17.7 0 32 14.3 32 32l0 160c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-82.7L342.6 374.6c-12.5 12.5-32.8 12.5-45.3 0L192 269.3 54.6 406.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l160-160c12.5-12.5 32.8-12.5 45.3 0L320 306.7 466.7 160 384 160z"/></svg>
                                </span>
                                <span class="kpiStateIcon" id="unchangedKpi">
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" fill="orange"><!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.--><path d="M432 256c0 17.7-14.3 32-32 32L48 288c-17.7 0-32-14.3-32-32s14.3-32 32-32l352 0c17.7 0 32 14.3 32 32z"/></svg>
                                </span>
                                {{diffNewMembersKPIValue}}
                            </label>
                            <p>Change</p>
                        </div>
                        <div class="kpi-comp-main-comp">
                            <label>{{lastNewMembersKPIValue}}</label>
                            <p>VS last Month</p>
                        </div>
                    </div>
                </div>
                <div class="tecGym-kpi-item">
                    <h6>Day Pass</h6>
                    <h1>{{currentDayPassKPIValue}}</h1>
                    <div class="kpi-comp-main">
                        <div class="kpi-comp-main-change">
                            <label [class]="dayPassStatus">
                                <span class="kpiStateIcon" id="downKpi">
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512" fill="red"><!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.--><path d="M384 352c-17.7 0-32 14.3-32 32s14.3 32 32 32l160 0c17.7 0 32-14.3 32-32l0-160c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 82.7L342.6 137.4c-12.5-12.5-32.8-12.5-45.3 0L192 242.7 54.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0L320 205.3 466.7 352 384 352z"/></svg>
                                </span>
                                <span class="kpiStateIcon" id="upKpi">
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512" fill="green"><!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.--><path d="M384 160c-17.7 0-32-14.3-32-32s14.3-32 32-32l160 0c17.7 0 32 14.3 32 32l0 160c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-82.7L342.6 374.6c-12.5 12.5-32.8 12.5-45.3 0L192 269.3 54.6 406.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l160-160c12.5-12.5 32.8-12.5 45.3 0L320 306.7 466.7 160 384 160z"/></svg>
                                </span>
                                <span class="kpiStateIcon" id="unchangedKpi">
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" fill="orange"><!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.--><path d="M432 256c0 17.7-14.3 32-32 32L48 288c-17.7 0-32-14.3-32-32s14.3-32 32-32l352 0c17.7 0 32 14.3 32 32z"/></svg>
                                </span>
                                {{diffDayPassKPIValue}}
                            </label>
                            <p>Change</p>
                        </div>
                        <div class="kpi-comp-main-comp">
                            <label>{{lastDayPassKPIValue}}</label>
                            <p>VS last Month</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div *ngIf="branch._id == '67728682419e66d9220356ec'" class="container">
            <div class="tecGymChartsMain">
                <div class="tecGymChartsItems monthWiseSalesChart">
                    <h3>Monthly Sales {{monthWiseSalesChartTitle}}</h3>
                    <canvas baseChart
                        [type]="monthWiseSalesChartType"
                        [data]="monthWiseSalesChartData"
                        [options]="monthWiseSalesChartOptions"
                        [plugins]="[monthWiseSalesDataLabels]">
                    </canvas>
                </div>
                <div class="tecGymChartsItems packageWiseSalesChart">
                    <h3>Package Wise Sales</h3>
                    <div style="position: relative;">
                        <canvas baseChart
                            [type]="packageWiseSalesChartType"
                            [data]="packageWiseSalesChartData"
                            [options]="packageWiseSalesChartOptions"
                            [plugins]="[packageWiseSalesDataLabels]">
                        </canvas>
                        <span class="registeredCount">{{totalPackageAmountForChart | shortCurrency:' ' }}</span>
                    </div>
                </div>
            </div>
        </div>
        <div *ngIf="branch._id == '67728682419e66d9220356ec'" class="container containerGap">
            <div class="tecGymChartsMain">
                <div id="memberAttendencechartid" class="tecGymChartsItems DailyMemberAttendanceChart">
                    <h3>Member Attendance</h3>
                    <canvas baseChart responsive
                        [data]="DailyMemberAttendanceChartData"
                        [options]="DailyMemberAttendanceChartOptions"
                        [type]="DailyMemberAttendanceChartType"
                        [plugins]="[DailyMemberAttendanceDataLabels]">
                    </canvas>
                </div>
            </div>
        </div>
        <div *ngIf="branch._id == '67728682419e66d9220356ec'" class="container containerGap">
            <div class="tecGymChartsMain threeRows">
                <div class="tecGymChartsItems NewMembersRegisteredChart">
                    <h3>New Members Registered</h3>
                    <div style="position: relative;">
                        <canvas baseChart
                            [data]="NewMembersRegisteredChartData"
                            [options]="NewMembersRegisteredChartOptions"
                            [type]="NewMembersRegisteredChartType"
                            [plugins]="[NewMembersRegisteredDataLabels]">
                        </canvas>
                        <span class="registeredCount">{{NewMembersRegisteredCount}}</span>
                    </div>
                </div>
                <div id="activeChartContainer" class="tecGymChartsItems ActiveMembersChart">
                    <h3>Total Active Members</h3>
                    <canvas baseChart
                        [data]="ActiveMembersChartData"
                        [options]="ActiveMembersChartOptions"
                        [type]="ActiveMembersChartType"
                        [plugins]="[ActiveMembersDataLabels]">
                    </canvas>
                </div>
                <div class="tecGymChartsItems MembershipFrozenKPI">
                    <h6>Frozen Members</h6>
                    <h1>{{currentMembershipFrozenKPIValue}}</h1>
                    <div class="kpi-comp-main">
                        <div class="kpi-comp-main-change">
                            <label [class]="membershipFrozenStatus">
                                <span class="kpiStateIcon" id="downKpi">
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512" fill="red"><!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.--><path d="M384 352c-17.7 0-32 14.3-32 32s14.3 32 32 32l160 0c17.7 0 32-14.3 32-32l0-160c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 82.7L342.6 137.4c-12.5-12.5-32.8-12.5-45.3 0L192 242.7 54.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0L320 205.3 466.7 352 384 352z"/></svg>
                                </span>
                                <span class="kpiStateIcon" id="upKpi">
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512" fill="green"><!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.--><path d="M384 160c-17.7 0-32-14.3-32-32s14.3-32 32-32l160 0c17.7 0 32 14.3 32 32l0 160c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-82.7L342.6 374.6c-12.5 12.5-32.8 12.5-45.3 0L192 269.3 54.6 406.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l160-160c12.5-12.5 32.8-12.5 45.3 0L320 306.7 466.7 160 384 160z"/></svg>
                                </span>
                                <span class="kpiStateIcon" id="unchangedKpi">
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" fill="orange"><!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.--><path d="M432 256c0 17.7-14.3 32-32 32L48 288c-17.7 0-32-14.3-32-32s14.3-32 32-32l352 0c17.7 0 32 14.3 32 32z"/></svg>
                                </span>
                                {{diffMembershipFrozenKPIValue}}
                            </label>
                            <p>Change</p>
                        </div>
                        <div class="kpi-comp-main-comp">
                            <label>{{lastMembershipFrozenKPIValue}}</label>
                            <p>VS last Month</p>
                        </div>
                    </div>
                </div>
                <div class="tecGymChartsItems activeMembersRateKPI">
                    <h6>Active Members</h6>
                    <h1>{{currentActiveMembersRateKPIValue}}</h1>
                    <div class="kpi-comp-main">
                        <div class="kpi-comp-main-change">
                            <label [class]="activeMembersStatus">
                                <span class="kpiStateIcon" id="downKpi">
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512" fill="red"><!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.--><path d="M384 352c-17.7 0-32 14.3-32 32s14.3 32 32 32l160 0c17.7 0 32-14.3 32-32l0-160c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 82.7L342.6 137.4c-12.5-12.5-32.8-12.5-45.3 0L192 242.7 54.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0L320 205.3 466.7 352 384 352z"/></svg>
                                </span>
                                <span class="kpiStateIcon" id="upKpi">
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512" fill="green"><!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.--><path d="M384 160c-17.7 0-32-14.3-32-32s14.3-32 32-32l160 0c17.7 0 32 14.3 32 32l0 160c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-82.7L342.6 374.6c-12.5 12.5-32.8 12.5-45.3 0L192 269.3 54.6 406.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l160-160c12.5-12.5 32.8-12.5 45.3 0L320 306.7 466.7 160 384 160z"/></svg>
                                </span>
                                <span class="kpiStateIcon" id="unchangedKpi">
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" fill="orange"><!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.--><path d="M432 256c0 17.7-14.3 32-32 32L48 288c-17.7 0-32-14.3-32-32s14.3-32 32-32l352 0c17.7 0 32 14.3 32 32z"/></svg>
                                </span>
                                {{diffActiveMembersKPIValue}}
                            </label>
                            <p>Change</p>
                        </div>
                        <div class="kpi-comp-main-comp">
                            <label>{{lastActiveMembersKPIValue}}</label>
                            <p>VS last Month</p>
                        </div>
                    </div>
                </div>
                <div class="tecGymChartsItems filler"></div>
            </div>
        </div>
        <!-- <div class="container containerGap">
            <div class="tecGymTableMain">
                <div class="tecGymTableItem">
                    <h3>Top 5 performing packages</h3>
                    <p-table [value]="[{}]">
                    <ng-template pTemplate="header">
                        <tr>
                        <th>Rank</th>
                        <th>Package Name</th>
                        <th>Sales Volume</th>
                        <th>Total Revenue</th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body">
                        <tr>
                        <td>1</td>
                        <td>Package One</td>
                        <td>120</td>
                        <td>$250,000</td>
                        </tr>
                        <tr>
                        <td>2</td>
                        <td>Package Two</td>
                        <td>110</td>
                        <td>$220,000</td>
                        </tr>
                        <tr>
                        <td>3</td>
                        <td>Package Three</td>
                        <td>100</td>
                        <td>$200,000</td>
                        </tr>
                        <tr>
                        <td>4</td>
                        <td>Package Four</td>
                        <td>90</td>
                        <td>$180,000</td>
                        </tr>
                        <tr>
                        <td>5</td>
                        <td>Package Five</td>
                        <td>80</td>
                        <td>$160,000</td>
                        </tr>
                    </ng-template>
                    </p-table>
                </div>
                <div class="tecGymTableItem">
                    <h3>Lowest Performing Packages</h3>
                    <p-table [value]="[{}]">
                    <ng-template pTemplate="header">
                        <tr>
                        <th>Rank</th>
                        <th>Package Name</th>
                        <th>Sales Volume</th>
                        <th>Total Revenue</th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body">
                        <tr>
                        <td>1</td>
                        <td>Package One</td>
                        <td>120</td>
                        <td>$250,000</td>
                        </tr>
                        <tr>
                        <td>2</td>
                        <td>Package Two</td>
                        <td>110</td>
                        <td>$220,000</td>
                        </tr>
                        <tr>
                        <td>3</td>
                        <td>Package Three</td>
                        <td>100</td>
                        <td>$200,000</td>
                        </tr>
                        <tr>
                        <td>4</td>
                        <td>Package Four</td>
                        <td>90</td>
                        <td>$180,000</td>
                        </tr>
                        <tr>
                        <td>5</td>
                        <td>Package Five</td>
                        <td>80</td>
                        <td>$160,000</td>
                        </tr>
                    </ng-template>
                    </p-table>
                </div>
                <div class="tecGymTableItem">
                    <h3>Top 5 performing trainer packages</h3>
                    <p-table [value]="[{}]">
                    <ng-template pTemplate="header">
                        <tr>
                        <th>Rank</th>
                        <th>Package Name</th>
                        <th>Sales Volume</th>
                        <th>Total Revenue</th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body">
                        <tr>
                        <td>1</td>
                        <td>Package One</td>
                        <td>120</td>
                        <td>$250,000</td>
                        </tr>
                        <tr>
                        <td>2</td>
                        <td>Package Two</td>
                        <td>110</td>
                        <td>$220,000</td>
                        </tr>
                        <tr>
                        <td>3</td>
                        <td>Package Three</td>
                        <td>100</td>
                        <td>$200,000</td>
                        </tr>
                        <tr>
                        <td>4</td>
                        <td>Package Four</td>
                        <td>90</td>
                        <td>$180,000</td>
                        </tr>
                        <tr>
                        <td>5</td>
                        <td>Package Five</td>
                        <td>80</td>
                        <td>$160,000</td>
                        </tr>
                    </ng-template>
                    </p-table>
                </div>
                <div class="tecGymTableItem">
                    <h3>Lowest Performing trainer Packages</h3>
                    <p-table [value]="[{}]">
                    <ng-template pTemplate="header">
                        <tr>
                        <th>Rank</th>
                        <th>Package Name</th>
                        <th>Sales Volume</th>
                        <th>Total Revenue</th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body">
                        <tr>
                        <td>1</td>
                        <td>Package One</td>
                        <td>120</td>
                        <td>$250,000</td>
                        </tr>
                        <tr>
                        <td>2</td>
                        <td>Package Two</td>
                        <td>110</td>
                        <td>$220,000</td>
                        </tr>
                        <tr>
                        <td>3</td>
                        <td>Package Three</td>
                        <td>100</td>
                        <td>$200,000</td>
                        </tr>
                        <tr>
                        <td>4</td>
                        <td>Package Four</td>
                        <td>90</td>
                        <td>$180,000</td>
                        </tr>
                        <tr>
                        <td>5</td>
                        <td>Package Five</td>
                        <td>80</td>
                        <td>$160,000</td>
                        </tr>
                    </ng-template>
                    </p-table>
                </div>
            </div>
        </div> -->
        <!-- <div class="container">
            <div class="tecGym-stats">
                <div class="tg-stats-item churn-Rate-stats">
                    <h3>Churn Rate</h3>
                    <canvas baseChart
                        [type]="ChurnRateChartType"
                        [data]="ChurnRateChartData"
                        [options]="ChurnRateChartOptions">
                    </canvas>
                    <div class="churnRateChartLabel">
                        <p class="currentChurnRate" [ngStyle]="getChurnRateStyle()">{{churnRateChartLabel}}</p>
                        <p class="churnRateSummary">{{chartLabelSummary}}</p>
                    </div>
                </div>
            </div>    
        </div> -->
    </div>
</div>